export const iconFontAwesomeUsersPeoplePersonFalling = (
	<i className="fa-solid fa-person-falling"></i>
);
